import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_PROGRESS_TESTS_PLAN_REQUEST = 'FETCH_PROGRESS_TESTS_PLAN_REQUEST';
export const FETCH_PROGRESS_TESTS_PLAN_SUCCESS = 'FETCH_PROGRESS_TESTS_PLAN_SUCCESS';
export const FETCH_PROGRESS_TESTS_PLAN_FAILURE = 'FETCH_PROGRESS_TESTS_PLAN_FAILURE';

const buildProgressTestPlanUrl = (groupId) => buildUrl(`/groups/${groupId}/progress-tests`);

export function fetchProgressTestPlanIfNeeded(groupId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildProgressTestPlanUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchProgressTestsPlan(groupId));
  };
}

export function fetchProgressTestsPlan(groupId) {
  return (dispatch) => {
    const url = buildUrl(`/groups/${groupId}/progress-tests`);
    const method = 'GET';

    return dispatch(fetchProgressTestsPlanRequest()).payload
      .then((response) => dispatch(fetchProgressTestsPlanSuccess(response)))
      .catch((error) => dispatch(fetchProgressTestsPlanFailure(error)));

    function fetchProgressTestsPlanRequest() {
      return ApiCall.createAction({
        type: FETCH_PROGRESS_TESTS_PLAN_REQUEST,
        payload: fetch(url),
        url,
        method,
        groupId,
      });
    }

    function fetchProgressTestsPlanSuccess(plan) {
      return ApiCall.createAction({
        type: FETCH_PROGRESS_TESTS_PLAN_SUCCESS,
        payload: plan,
        url,
        method,
        groupId,
      });
    }

    function fetchProgressTestsPlanFailure(error) {
      return ApiCall.createAction({
        type: FETCH_PROGRESS_TESTS_PLAN_FAILURE,
        error,
        url,
        method,
        groupId,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/ProgressTestsPlan/actions.js